import React from 'react';
import styled from 'styled-components';
import PageTransition from 'gatsby-v2-plugin-page-transitions';

import Page from '../components/global/page';
import EducationTemplate from '../templates/education-template';

const StyledPage = styled.div`
	.inner nav.pages ul li:not(.button-link) a {
		&.education {
			font-weight: 700;
		}
	}

	[class*='OpenerStyle'] {
		.text-col {
			p {
				font-size: 1.25rem;
				line-height: 1.5;
			}
		}
	}
`;

const EducationPage = () => (
	<PageTransition>
		<StyledPage>
			<Page
				title="Education"
				desc="Learn more about mental health and its effects on our community. Let's Start Talking!"
			>
				<EducationTemplate />
			</Page>
		</StyledPage>
	</PageTransition>
);

export default EducationPage;
